<template>
<div></div>
</template>


<script>
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
  data() {
    return {
      id:this.$route.query.id
    };
  },
  created(){
    if(!this.checkIfMobile()){
      this.$alert('请用手机访问', '下载提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.$router.go(-1);

        }
      });
      return
    }
    this.getvisitorId()
  },
  mounted() {

  },
  methods: {
    toDetail(visitorId){
      this.axios({
        method: "get",
        url: "/rj-project-info/get-url/"+this.id,
        params: {
          uuid:visitorId
        },
      }).then((res) => {
        window.location.href = res.data.data.url
      });

    },
    async getvisitorId() {
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      const visitorId = result.visitorId
      this.toDetail(visitorId)

    },
    checkIfMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    }

  },
};
</script>

<style scoped>

</style>